import React from 'react';
import { Typography, Button, List, Tag, Empty, Space } from 'antd';
import { BellOutlined, CheckOutlined } from '@ant-design/icons';
import { useListNotificationsQuery, useMarkReadMutation, useMarkAllReadMutation } from './notificationsApi';

const { Title, Text } = Typography;

export default function NotificationsPage() {
  const { data, isLoading } = useListNotificationsQuery();
  const [markRead] = useMarkReadMutation();
  const [markAllRead] = useMarkAllReadMutation();

  const notifications = data?.items || [];
  const unread = notifications.filter((n) => !n.readAt);

  return (
    <div>
      <section style={{ marginBottom: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, flexWrap: 'wrap' }}>
          <div>
            <Title
              level={3}
              style={{ margin: 0, fontFamily: 'var(--df-font-display)', color: 'var(--df-text)' }}
            >
              <BellOutlined style={{ marginRight: 10, color: 'var(--df-accent)' }} />
              Notifications
            </Title>
            <Text style={{ display: 'block', marginTop: 6, color: 'var(--df-text-secondary)' }}>
              Deal matches, replies, and community activity in one place.
            </Text>
          </div>
          {unread.length > 0 && (
            <Button
              icon={<CheckOutlined />}
              onClick={() => markAllRead()}
              style={{ borderRadius: 8, fontWeight: 600, height: 40 }}
            >
              Mark all read ({unread.length})
            </Button>
          )}
        </div>
      </section>

      {notifications.length === 0 && !isLoading ? (
        <div
          style={{
            padding: '64px 24px',
            textAlign: 'center',
            borderRadius: 12,
            border: '1px dashed var(--df-border)',
            background: 'rgba(255,255,255,0.55)',
          }}
        >
          <Empty description="No notifications yet" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </div>
      ) : (
        <div
          style={{
            borderRadius: 12,
            border: '1px solid var(--df-border)',
            background: 'var(--df-surface-elevated)',
            boxShadow: 'var(--df-shadow)',
            overflow: 'hidden',
          }}
        >
          <List
            loading={isLoading}
            dataSource={notifications}
            renderItem={(item) => (
              <List.Item
                style={{
                  background: item.readAt ? 'transparent' : 'rgba(11, 58, 92, 0.05)',
                  padding: '14px 18px',
                  cursor: 'pointer',
                  borderBottom: '1px solid var(--df-border-subtle)',
                  minHeight: 56,
                }}
                onClick={() => {
                  if (!item.readAt) markRead(item.publicId);
                  if (item.actionUrl) window.location.href = item.actionUrl;
                }}
                actions={
                  !item.readAt
                    ? [(
                      <Button
                        key="read"
                        size="small"
                        type="text"
                        icon={<CheckOutlined />}
                        aria-label="Mark as read"
                        style={{ minWidth: 44, minHeight: 44 }}
                        onClick={(e) => { e.stopPropagation(); markRead(item.publicId); }}
                      />
                    )]
                    : undefined
                }
              >
                <List.Item.Meta
                  title={(
                    <Space wrap>
                      <Text strong={!item.readAt} style={{ color: 'var(--df-text)' }}>{item.title}</Text>
                      {!item.readAt && (
                        <Tag
                          style={{
                            borderRadius: 6,
                            border: 'none',
                            background: 'rgba(232, 93, 4, 0.12)',
                            color: 'var(--df-accent)',
                            fontWeight: 600,
                            fontSize: 11,
                          }}
                        >
                          New
                        </Tag>
                      )}
                    </Space>
                  )}
                  description={(
                    <div>
                      {item.body && (
                        <Text style={{ color: 'var(--df-text-secondary)', display: 'block' }}>{item.body}</Text>
                      )}
                      <Text style={{ fontSize: 12, color: 'var(--df-text-muted)' }}>
                        {item.createdAt ? new Date(item.createdAt).toLocaleString() : ''}
                      </Text>
                    </div>
                  )}
                />
              </List.Item>
            )}
          />
        </div>
      )}
    </div>
  );
}
